import login from "@/router/pages/employee/auth/login";
import forgotPassword from "@/router/pages/employee/auth/forgotPassword";

const employeeAuth = [...login, ...forgotPassword];

export default employeeAuth;
